import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const SaleIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 100 100">
      <path
        d="M59.4228 7L79.6106 82.3422L36.1879 93.9773L16 18.6351L29.0268 15.1446C30.231 19.6387 34.9152 22.0669 39.8364 20.7483C44.7577 19.4297 47.6001 14.9846 46.3959 10.4905L59.4228 7Z"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.5134 62.1701L84.5079 18.896L68.5571 17.0764"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="40.4595"
        y1="82.7415"
        x2="38.6478"
        y2="75.9801"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="50.1188"
        y1="80.1533"
        x2="48.3071"
        y2="73.3918"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="59.778"
        y1="77.5652"
        x2="57.9663"
        y2="70.8037"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="69.4373"
        y1="74.9769"
        x2="67.6256"
        y2="68.2154"
        stroke="#3F1D75"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M42.3533 53.2783C43.3 56.8113 47.29 59.0555 50.9032 58.0874C54.5165 57.1192 56.8498 53.1807 55.9032 49.6477C54.9565 46.1147 50.9665 43.8705 47.3533 44.8387C43.74 45.8068 39.75 43.5626 38.8034 40.0296C37.8567 36.4966 40.19 32.5581 43.8033 31.5899C47.4166 30.6218 51.4065 32.866 52.3532 36.399"
        stroke="#8647FD"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9033 58.0874L52.0866 62.5036"
        stroke="#8647FD"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.62 27.1737L43.8033 31.5899"
        stroke="#8647FD"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
